export const styles = {
  navBar: {
    backgroundColor: "#6e1a22",
  } as React.CSSProperties,
  dropdownStyle: {
    display: "flex",
    color: "rgba(0, 0, 0, 0)",
  },
  linkContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
